import { render, staticRenderFns } from "./subwayrunner.vue?vue&type=template&id=0f843543"
import script from "./subwayrunner.vue?vue&type=script&lang=js"
export * from "./subwayrunner.vue?vue&type=script&lang=js"
import style0 from "./subwayrunner.vue?vue&type=style&index=0&id=0f843543&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports